import workspaceQuery from 'graphql/queries/product/LuckinsImportWorkspaceQuery.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const LuckinsImport: EntityType = {
  type: 'LuckinsImport',
  title: 'Luckins Imports',
  workspaceUrl: '/Products/Luckins/LuckinsImport/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'LUCKINS_IMPORT',
  operations: ALLOW_VIEW,
};

export default LuckinsImport;
